import { isPlatformBrowser } from "@angular/common";
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnDestroy, OnInit, Output, PLATFORM_ID, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { NavigationEnd, NavigationExtras, Router } from "@angular/router";
import { NbMenuBag, NB_WINDOW } from "./extended-nebular-theme";
// import { convertToBoolProperty, NbBooleanInput } from "@nebular/theme/components/helpers";
// // import { convertToBoolProperty, NbBooleanInput } from "@nebular/theme/components/helpers";
import { BehaviorSubject, filter, firstValueFrom, lastValueFrom, Subject, takeUntil } from "rxjs";
import { DgMenuItem, PermissionConditionObj, UserPermissions } from './types';
import { environment } from "src/environments/environment";
import { AuthService } from "../services/auth.service";
import { DgMenuService } from "./menu.service";
import { SidebarService } from '../services/sidebar.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { NbToggleStates } from '@nebular/theme';
import { DgMenuItemComponent } from './menu-item.component';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { IUserProfile } from '../interfaces/IProfile';
import { TransmitService } from 'src/app/core/services/transmit.service';
import {setUserName} from 'src/app/core/common/public';

@Component({
    selector: 'dg-menu',
    styleUrls: ['./menu.component.scss'],
    templateUrl: './menu.component.html',
    standalone: false
})
export class DgMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  buildNumber = environment.buildNumber;
  lastBuildDate: string;
  public isMobileSize: boolean = false;
  public showSidebar: boolean = false;
  permissions: any = {};
  public showMenu: boolean = false;
  notifier = new Subject<void>();
  userData: IUserProfile = {
    avatar: '',
    first_name: '',
    is_complete: true,
    last_name: '',
    national_code: '',
    phone: '',
    pk: 0,
    user_type: '',
    extra_data: {
      name: '',
      national_id: '',
      registration_number: '',
    },
    email: '',
    is_active: false,
    last_activity: 0,
  };

  @ViewChild('sidebar') sidebar: ElementRef;
  @ViewChild('menu') menu: ElementRef;

  @ViewChildren(DgMenuItemComponent) DgMenuItemsComponent: QueryList<DgMenuItemComponent>[];
  /**
   * Tags a menu with some ID, can be later used in the menu service
   * to determine which menu triggered the action, if multiple menus exist on the page.
   *
   * @type {string}
   */
  @Input() tag: string;
  @Input() toggleState: NbToggleStates = NbToggleStates.Expanded;
  // @Output() modeChange = new EventEmitter
  /**
   * List of user permissions.
   * @type List<string>
   */
  @Input() userPermissions: UserPermissions;
  /**
   * List of menu items.
   * @type List<NbMenuItem> | List<any> | any
   */
  @Input() items: DgMenuItem[];
  /**
   * Collapse all opened submenus on the toggle event
   * Default value is "false"
   * @type boolean
   */
  @Input() header: DgMenuItem[];

  @Input()
  get autoCollapse(): boolean {
    return this._autoCollapse;
  }
  set autoCollapse(value: boolean) {
    // this._autoCollapse = convertToBoolProperty(value);
  }
  protected _autoCollapse: boolean = false;
  // static ngAcceptInputType_autoCollapse: NbBooleanInput;
  protected destroy$ = new Subject<void>();

  constructor(
    protected _menu: DgMenuService,
    public _sidebarService: SidebarService,
    protected _router: Router,
    public _authService: AuthService,
    private breakpointObserver: BreakpointObserver,
    public env: EnvironmentService,
    private transmit: TransmitService,
     // @Inject(PLATFORM_ID) protected platformId,
  ) {
    if (this.buildNumber > 10) {
      let tmp = new Date(this.buildNumber * 1000);
      if (tmp.getFullYear() > 2010) {
        this.lastBuildDate = 'آخرین بروز رسانی: ' + tmp.toDateString() + ' - ' + tmp.toTimeString();
      }
    }
  }


  goToPage(link) {
    this._router.navigateByUrl(link);
  }

  goToWallet() {
    this._router.navigateByUrl('/payment/payment-list')
  }

  toggleSidebar() {
    this._sidebarService.toggle('menu-sidebar');
  }

  hideSidebar() {
    this._sidebarService.toggleVisibility();
    document.body.classList.remove('mouse-disable');
  }

  hideMenu() {
    this._sidebarService.toggleMenuVisibility();
    document.body.classList.remove('mouse-disable');
  }
  setToggleState() {
    this._sidebarService.getSidebarState("menu-sidebar").pipe(takeUntil(this.destroy$)).subscribe((value) => {
        this.toggleState = value;
      })
  }

  setShowSidebar(): void {
    this._sidebarService
      .getSidebarVisibility()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.showSidebar = !this.showSidebar;
        document.body.classList.add('mouse-disable');
      });
  }

  setShowMenu(): void {
    this._sidebarService
      .getMenuVisibility()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.showMenu = !this.showMenu;
        document.body.classList.add('mouse-disable');
      });
  }

  private setIsMobileSize(): void {
    this.breakpointObserver.observe([
      "(max-width: 1140px)"
    ]).pipe(takeUntil(this.destroy$)).subscribe((result: BreakpointState) => {
        this.isMobileSize = result.matches;
        this.showSidebar = false;
        this.showMenu = false;
      });
  }

  async ngOnInit() {
    this._authService.onPermissionsUpdated$.pipe(takeUntil(this.destroy$)).subscribe(async (userPermissions) => {
        if(!Object.keys(userPermissions).length) return
        this.permissions.upgradeUser = userPermissions.all || userPermissions?.groups?.includes('legal_user') || userPermissions?.groups?.includes('lawyer') || userPermissions?.groups?.includes('coworker')
        for (const item of this.items) {
          await this._menu.setPermissions(item, userPermissions);
          this._menu.isSelectedLink(item, window.location.href)
        }
      });
    this.setToggleState();
    this.setIsMobileSize();
    this.setShowSidebar();
    this.setShowMenu();
    this._router.events.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.showSidebar = false;
        this.showMenu = false;
        document.body.classList.remove('mouse-disable');
        for (const item of this.items) {
          this._menu.isSelectedLink(item, window.location.href)
        }
      }
    });

    this.transmit
      .listen('profile-data')
      .pipe(takeUntil(this.notifier))
      .subscribe((it) => {
        if (!it) return;
        this.userData = this.env.profileInfo;
      });

    if (this.isMobileSize) {
      document.addEventListener('click', this.onClickOutside.bind(this));
    }
  }

  mouseLeave() {
    if (this.toggleState === NbToggleStates.Collapsed) {
      this.DgMenuItemsComponent.map((item) => {
        item['menuItem']['expanded'] = false
      });
    }
  }

  ngAfterViewInit() {
    // setTimeout(() => this.menuInternalService.selectFromUrl(this.items, this.tag, this.autoCollapse));
  }

  onMenuSelectItem(item: DgMenuItem){
    this._router.navigateByUrl(item.link);
  }

  onClickOutside(event: MouseEvent) {
    // Check if it's in mobile
    if (this.isMobileSize) {
      const target = event.target as HTMLElement;

      // Check if click target is not sidebar menu or manu button
      if (
        !this.sidebar.nativeElement.contains(target) &&
        !target.closest('.personal-info')
      ) {
        this.showSidebar = false;
      }

      // Check if click target is not header menu or manu button
      if (
        !this.menu.nativeElement.contains(target) &&
        !target.closest('.sidebar-toggle')
      ) {
        this.showMenu = false;
      }
      if (!this.showSidebar && !this.showMenu) {
        document.body.classList.remove('mouse-disable');
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    document.removeEventListener('click', this.onClickOutside.bind(this));
  }

  setUserName() {
    return setUserName(this.userData)
  }
}